import React from 'react'

import NavigationSection from "../../../core/model2/navigation/navigation-section"
import {UIType} from "../../ui/@const";

type Props = {
    className?          : string,

    section?            : NavigationSection,    // nahrena on ???
}

export default function Navigation_Separator(props:Props) {

    // if (gd.ui.type === UIType.LEFT || gd.ui.type === UIType.TOP || (gd.ui.type === UIType.GOODDAY_MODERN && !gd.user.settings.skin.showNavbarLabels )) {

    if (gd.ui.type === UIType.LEFT || gd.ui.type === UIType.TOP || gd.ui.type === UIType.GOODDAY_MODERN) {

        return (
            <div className={Classes("delimiter", props.className)} />
        )
    } else {
        return null
    }


}
